const featuresData = [
  {
    icon: 'ri-timer-flash-line',
    title: '7×24h 实时更新',
    desc: '编辑团队全天候监控全网热点，第一时间上线最新黑料内容，真正24小时不打烊。',
    color: 'primary',
  },
  {
    icon: 'ri-shield-check-line',
    title: '完全免费观看',
    desc: '无需注册、无需付费、无需会员，所有黑料在线视频内容均可免费高清观看。',
    color: 'accent',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台支持',
    desc: '电脑、平板、手机多端适配，网页端和APP端数据同步，随时随地畅享黑料内容。',
    color: 'primary',
  },
  {
    icon: 'ri-layout-grid-line',
    title: '12大内容板块',
    desc: '涵盖明星八卦、综艺热点、网红动态、影视吐槽等12大话题板块，满足各类吃瓜需求。',
    color: 'accent',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载体验',
    desc: '自研视频加速技术，即使在弱网环境下也能流畅播放，给你丝滑的观看体验。',
    color: 'primary',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">平台特色</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            为什么选择黑料不打烊？五大特色让你爱上这里
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {featuresData.map((feature, idx) => (
            <div
              key={idx}
              className="group bg-background-100 border border-background-300/30 rounded-xl p-5 md:p-6 text-center transition-all hover:border-primary-500/20 hover:bg-background-200/50 cursor-pointer"
            >
              <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4 ${
                feature.color === 'primary' ? 'bg-primary-500/10' : 'bg-accent-500/10'
              }`}>
                <i className={`${feature.icon} text-2xl ${
                  feature.color === 'primary' ? 'text-primary-400' : 'text-accent-400'
                }`}></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900">
                {feature.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}